var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'icon-stat d-flex',
    `align-items-${_vm.alignItems}`,
    { 'justify-content-center': _vm.align === 'center' },
    { 'justify-content-start': _vm.align === 'left' },
    { 'justify-content-end': _vm.align === 'right' },
  ]},[_c('font-awesome-icon',{staticClass:"icon-stat-icon mr-3",attrs:{"icon":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"stat"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }